import { loginByUsername, logout, getUserInfo, requestQueryMenu, dealMenuData, routerMatch, filterAsyncRouter } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { asyncRouterMap, constantRouterMap, constantWhiteRouterMap } from '@/routes'

const user = {
  state: {
    user: '',
    status: '',
    code: '',
    token: getToken(),
    name: JSON.parse(sessionStorage.getItem('name')) || '',
    avatar: '',
    introduction: '',
    roles: [],
    setting: {
      articlePlatform: []
    }
  },

  mutations: {
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_NAME: (state, name) => {
      state.name = name
      sessionStorage.setItem('name', JSON.stringify(name))
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    // 用户名登录
    LoginByUsername ({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        loginByUsername(username, userInfo.password, userInfo.checkCode, userInfo.deviceId).then(response => {
          const data = response.data
          if (data.code == 200) {
            commit('SET_TOKEN', data.data.access_token)
            setToken(response.data.data.access_token)
          } if (data.code == 5006) {
            commit('SET_TOKEN', data.data.access_token)
            setToken(response.data.data.access_token)
          }
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetUserInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(response => {
          if (!response.data) { // 由于mockjs 不支持自定义状态码只能这样hack
            reject('error')
          }
          const data = response.data
          commit('SET_NAME', data.data.user.username)
          sessionStorage.setItem('user', JSON.stringify(data.data.user))
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户权限
    GetUserAccess ({ commit, state }) {
      return new Promise((resolve, reject) => {
        requestQueryMenu().then(response => {
          if (response.data.code !== 200) { // 由于mockjs 不支持自定义状态码只能这样hack
            reject(response.data.msg)
            LogOut()
          } else {
            let data = response.data.data
            // 配置菜单 dealMenuData()用于把权限放到一个permission的数组里
            const menu = dealMenuData(data)
            let result = null
            routerMatch(menu, asyncRouterMap).then(res => {
              // this.$router.addRoutes()
              result = res[0]
              // commit('SET_ROUTERS', result)
              console.log('router === ', result)
              let obj = {};
              let peon = result.reduce((cur, next) => {
                obj[next.name] ? "" : obj[next.name] = true && cur.push(next);
                return cur;
              }, []) //设置cur默认类型为数组，并且初始值为空的数组
              resolve(peon)
              // if (process.env.NODE_ENV === 'development') {
              //   resolve(asyncRouterMap)
              // } else {
              //   resolve(peon)
              // }
            })
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 重置密码后，登录，默认只见个人中心
    ResetPwdONlyPersonal ({ commit, state }) {
      return new Promise((resolve, reject) => {
        let result = null
        filterAsyncRouter(constantWhiteRouterMap).then(res => {
          // this.$router.addRoutes()
          result = res[0]
          commit('SET_ROUTERS', result)
          resolve(result)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 第三方验证登录
    // LoginByThirdparty({ commit, state }, code) {
    //   return new Promise((resolve, reject) => {
    //     commit('SET_CODE', code)
    //     loginByThirdparty(state.status, state.email, state.code).then(response => {
    //       commit('SET_TOKEN', response.data.token)
    //       setToken(response.data.token)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 登出
    LogOut ({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_ROUTERS', [])
          commit('SET_NAME', '')
          sessionStorage.clear()
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_ROUTERS', [])
        commit('SET_NAME', '')
        sessionStorage.clear()
        removeToken()
        resolve()
      })
    },

    // 动态修改权限
    ChangeRoles ({ commit }, role) {
      return new Promise(resolve => {
        commit('SET_TOKEN', role)
        setToken(role)
        getUserInfo(role).then(response => {
          const data = response.data
          commit('SET_ROLES', data.roles)
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          commit('SET_INTRODUCTION', data.introduction)
          resolve()
        })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js